// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KvjnG","top":"styles_top__VGG7o"};